// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/stations/:stationId\",\"regex\":\"^/stations/([^/]+)$\",\"paramNames\":[\"stationId\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"}],\"isrRoutes\":[\"/stations/:stationId\"]}";globalThis["_sentryNextJsVersion"] = "16.2.4";import * as Sentry from '@sentry/nextjs';

const sentryDsn = process.env.NEXT_PUBLIC_SENTRY_DSN;
const sentryEnvironment = process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT ?? process.env.ENVIRONMENT;

Sentry.init({
  dsn: sentryDsn,
  environment: sentryEnvironment,

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Enable sending user PII (Personally Identifiable Information)
  // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
